<template>
	<div id="autoCompleteInputComponent">
		<button v-show="false" ref="btnClear" @click="clear"></button>
		<button v-show="false" ref="btnSetDataDefault" @click="setDataDefault"></button>
		<div class="autocomplete-input-componenet">
			<input text="text"
					v-model="string"
					@focus="focusF"
					@blur="blourF"
					:class="classLocal"
					:placeholder="placeholderLocal"
					@keyup="keyupLocal($event)"/>
			<button @click="clear" v-show="false" ref="clear">Limpiar</button>
			<small class="form-text text-muted" v-show="searching">
				<i class="spinner-border" style="width: 16px; height: 16px"></i> <i>Buscando información </i></small>
			<small class="form-text text-muted" v-show="(!searching)">
				<i>Escriba y seleccione un item de la lista</i>
				<i class="fas fa-check text-success float-right" v-if="data.id > 0" :title="'Código seleccionado: ' + data.id"></i>
				<i class="fas fa-exclamation-triangle text-warning float-right" v-else title="No ha seleccionado un item de la lista"></i>
			</small>
			<ul class="list-result-input" v-show="showList">
				<li v-for="(item, index) in list" :key="index" @click="selectItem(item)">
					<span>{{ item.text }}</span>
					<i class="float-right"><small>{{ item.extra }}</small></i>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
    import mixin from '@/mixins'
    import errors from '@/mixins/errors.js'
    import axiosAction from '@/mixins/axiosAction.js'

	export default {
		name: 'AutoCompleteInputComponent',
		mixins: [mixin, errors, axiosAction],
		props: ['_class', '_placeholder', '_path', '_itemDefault'],
		data () {
			return {
				list: [],
				string: '',
				searching: false,
				minChar: 3,
				data: {
					id: 0,
					string: '',
					item: []
				},
				focus: false
			}
		},
		computed: {
			classLocal() {
				return this._class
			},
			placeholderLocal() {
				return this._placeholder
			},
			showList() {
				return (this.string.length > this.minChar && this.list.length > 0 && this.focus)
			}
		},
		methods: {
			blourF() {
				setTimeout(() => {
					this.focus = false
					this.list = []
				}, 300);
			},
			clear() {
				this.string = ''
				this.list = []
				this.clearData()
			},
			clearData() {
				this.data.id = 0
				this.data.string = ''
				this.data.item = {}
			},
			focusF() {
				this.focus = true
			},
			getData() {
				this.searching = true
				let param = '?search=' + this.string
				this.axiosActionIS(this._path + param, 'GET', 'getDataResult')
			},
			getDataResult(response) {
				if(response.data.success === true) {
					this.list = response.data.data
				} else {
					console.log('No encontró nada o estal mal el formato de lo obtenido', response.data)
				}
				this.searching = false
			},
			keyupLocal(event) {
				if(this.data.id > 0) {
					this.clearData()
					this.$emit('actionSelectItem', this.data)
				}

				this.string = this.string.trimStart()
				if(this.string.length > this.minChar) {
					this.getData()
				} else {
					this.list = []
				}
			},
			resultAxiosLocal(responseLocal, response) {
				this.$emit('hideLockScreen')
				switch(responseLocal) {
					case 'getDataResult': this.getDataResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
			},
			selectItem(item) {
				this.string = item.text
				this.list = []
				this.data.id = item.id
				this.data.string = item.text
				this.data.item = item
				this.$emit('actionSelectItem', this.data)
			},
			setDataDefault() {
				if(this._itemDefault != null && this._itemDefault != undefined) {
					this.string = this._itemDefault.text
					this.list = []
					this.data.id = this._itemDefault.id
					this.data.string = this._itemDefault.text
					this.data.item = this._itemDefault
					this.$emit('actionSelectItem', this.data)
				} else {
					console.log('No hay datos para setear este autocomplete')
				}
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	.autocomplete-input-componenet {
		position: relative;
		ul {
			margin-top: -19px;
			border: 1px solid #ccc;
			background-color: white;
			position: absolute;
			z-index: 1;
			width: 100%;
			box-shadow: 1px 1px #ccc;
			li {
				padding: 5px 10px;
				border-bottom: 1px solid #ddd;
			}
			li:hover {
				background: #5bc0de;
				color:#fff;
				cursor: pointer;
			}
		}
	}
</style>